import { CURRENCY_CODE } from "@/lib/constant";
import {
  getFormattedProductItems,
  getProductNames,
  getProductSKUs,
} from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackPaymentInitiated = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackPaymentInitiatedEvent = useCallback(
    (cartInfo, selectedPaymentMethod) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }

      if (window.webengage) {
        if (cartInfo && selectedPaymentMethod) {
          const { cartTotal, couponName, itemsQuantity, lineItems } = cartInfo;
          const { total, tax, subTotal, shippingCharges, couponDiscount } =
            cartTotal;
          const eventData = {
            total,
            couponName,
            shippingCharges,
            discount: couponDiscount,
            tax,
            paymentMode: selectedPaymentMethod,
            subTotal,
            product_id: getProductSKUs(lineItems),
            product_names: getProductNames(lineItems),
            currency: CURRENCY_CODE,
            items: getFormattedProductItems(lineItems, couponName),
            no_of_product: itemsQuantity,
          };
          window.webengage.track("payment_initiated", eventData);
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackPaymentInitiatedEvent };
};

export default useTrackPaymentInitiated;
